import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=2f9254cb&scoped=true"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonGroup.vue?vue&type=style&index=0&id=2f9254cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9254cb",
  null
  
)

export default component.exports